import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/apiClient";
import type { StaffByRole, StaffTotalsByRole } from "@shared/types/staff";

export const REFRESH_INTERVAL_MS = 5000;

export function useStaff() {
  return useQuery({
    queryKey: ["wallboard", "staff"],
    queryFn: () => apiGet<StaffByRole>("/api/wallboard/staff"),
    refetchInterval: REFRESH_INTERVAL_MS,
  });
}

export function useStaffTotals() {
  return useQuery({
    queryKey: ["wallboard", "staff-totals"],
    queryFn: () => apiGet<StaffTotalsByRole>("/api/wallboard/staff-totals"),
    refetchInterval: REFRESH_INTERVAL_MS,
  });
}
